import React, { Component } from 'react';
import './progress.css'
// import { Doughnut } from 'react-chartjs-2';
import { Doughnut } from 'react-chartjs-2';

import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
const data = {
    labels: [
        'React JS + Redux',
        'Vue JS + Vuex',
        'Nuxt JS',
        'Node JS',
        'CSS',
        'React Native + Redux',
        'html5',
        'AWS',
        'Typescript',
        'Firebase',
        'MongoDB Atlas',
        'MongoDB'
    ],
    datasets: [{
        data: [80, 75, 75, 70, 75, 75, 75, 65, 60, 70, 70, 60],
        backgroundColor: [
            '#465e9a',
            '#8b7680',
            '#c4c4c6',
            '#363f45',
            '#3d4cb7',
            '#795446',
            '#88c440',
            '#ff9700',
            '#0f93f5',
            '#009587',
            '#ffec16',
            '#9c1ab1'
        ],
        hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
        ]
    }]
};
// const data = {
//     labels: [
//         'Typescript',
//         'Javascript',
//         'Css/SASS',
//         'Firebase',
//         'html',
//         'psd to html',
//         'React JS',
//         'React Native',
//     ],
//     datasets: [{
//         data: [85, 60, 60, 80, 80, 70, 80, 70],
//         backgroundColor: [
//             '#004489',
//             '#e1e1d6',
//             '#d3d9df',
//             '#989898',
//             '#565656',
//             '#dbdbce',
//             '#b2c7d0',
//             '#ccdde0',
//         ],
//         borderColor: [
//             '#004489',
//             '#e1e1d6',
//             '#d3d9df',
//             '#989898',
//             '#565656',
//             '#dbdbce',
//             '#b2c7d0',
//             '#ccdde0',
//         ],
//         color: [
//             "red",
//             "blue"
//         ]

//     }]
// };



const EmployeesGrpah = [
    { '%': 80, name: "Javascript" },
    { '%': 90, name: "React JS" },
    { '%': 60, name: "Vue JS" },
    { '%': 70, name: "React Native" },
    { '%': 85, name: "Html" },
    { '%': 75, name: "CSS" },
    { '%': 80, name: "Bootstrap" },
    { '%': 65, name: "Firebase" },
    { '%': 50, name: "Node JS" },
    { '%': 50, name: "Mongo DB" },
]
class ProgressDiv extends Component {
    constructor(props) {
        super(props)
        this.state = {
            scrolling: false
        }
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll = (event) => {
        if (window.scrollY > 2000 && this.state.scrolling !== true) {
            this.setState({ scrolling: true });
        }
    }
    render() {

        return (
            <div className='Progress'  >
                <div className='Progresschild1 secondGraTTip'>
                    {/* {
                    } */}
                    {
                        this.state.scrolling ?

                            <ResponsiveContainer width='100%' height={300}>

                                <Doughnut data={data} />


                            </ResponsiveContainer>
                            : null
                    }
                </div>

            </div>
        );
    }
}

export default ProgressDiv;



// WEBPACK FOOTER //
// ./src/containers/progressdiv/progressdiv.js